import React, { useCallback, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";

import toast from "react-hot-toast";
import _ from "lodash";
import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import FormButtons from "views/components/formbuttons";
import FormHeader from "views/components/formheader";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { dataset } from "@core/layouts/utils";
import { isSpaceValidateTextField } from "@core/utils/Const";
import Loader from "@core/helper/Loader";

const FormControlLabel = styled(MuiFormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
}));

const AddCreateSubAdmin = (props) => {
  const {
    open,
    toggle,
    type,
    heading,
    onSubmitCreateSubAdminList,
    updateData,
  } = props;

  const [adminList, setAdminList] = useState(
    type === "add" ? dataset : [updateData.config]
  );
  const [selectcheck, setSelectCheck] = useState("");
  const defaultValues = {
    name: "",
    email: "",
    password: "",
  };

  const {
    setValue,
    reset,
    control,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });
  const resetAll = useCallback(() => {
    const dataset = JSON.parse(JSON.stringify(adminList));
    dataset.map((item) => {
      return Object.entries(item).map(([key, value]) => {
        value.view = false;
        value.edit = false;
        value.delete = false;

        return value;
      });
    });

    setAdminList(dataset);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    selectAll = false;
  }, []);
  const resetToEmptyValues = useCallback(() => {
    setValue("name", "");
    setValue("email", "");
    setValue("password", "");

    resetAll();
  }, [resetAll, setValue]);

  const resetToStoredValues = useCallback(() => {
    if (type === "edit") {
      const event = {
        userName: updateData?.username,
        email: updateData?.email,
      };

      setValue("name", event.userName || "");
      setValue("email", event.email || "");
    }
  }, [setValue, type, updateData?.email, updateData?.username]);

  useEffect(() => {
    if (type === "edit") {
      resetToStoredValues();
    } else {
      resetToEmptyValues();
    }
  }, [open, resetToStoredValues, resetToEmptyValues, type]);
  useEffect(() => {}, []);

  const handleClose = () => {
    clearErrors();
    if (type === "add") {
      reset(defaultValues);
    }

    toggle();
  };

  const selectOne = (e, g) => {
    const dataset = JSON.parse(JSON.stringify(adminList));

    dataset.map((item) => {
      return Object.entries(item).forEach(([key, value]) => {
        const valueadd = e.target.checked;
        if (value.view) {
          view_All = true;
        } else {
          view_All = false;
        }
        if (e.target.name === "view") {
          if (!value.view) {
            view_All = false;
          } else {
            view_All = true;
          }
        }
        if (e.target.name === "all") {
          if (value.view) {
            view_All = true;
          }
        }
        if (value) {
          setSelectCheck("");
        }
        if (key === g) {
          if (e.target.name === "all") {
            value.view = valueadd;
            value.edit = valueadd;
            value.delete = valueadd;
          } else if (e.target.name === "view") {
            if (value.edit || value.delete) {
              value.view = true;
            }

            if (!value.edit && !value.delete) {
              value.view = valueadd;
            }
          } else if (e.target.name === "edit") {
            value.edit = valueadd;
            value.view = true;
          } else {
            value.delete = valueadd;
            value.view = true;
          }
        }

        return value;
      });
    });

    setAdminList(dataset);
  };

  const setDeteleAll = (e) => {
    const delete1 = JSON.parse(JSON.stringify(adminList));
    delete1.map((item) => {
      return Object.entries(item).forEach(([key, value]) => {
        if (e.target.checked && edit_All && view_All) {
          value.all = true;
          selectAll = true;
        } else {
          selectAll = false;
        }
        if (!view_All) {
          value.view = true;
        }
        if (e.target.checked) {
          value.view = true;
        }
        if (value) {
          setSelectCheck("");
        }
        value.delete = e.target.checked;
        return value;
      });
    });

    view_All = true;
    delete_All = e.target.checked;
    setAdminList(delete1);
  };

  const setEditAll = (e) => {
    const edit1 = JSON.parse(JSON.stringify(adminList));

    edit1.map((item) => {
      return Object.entries(item).forEach(([key, value]) => {
        if (e.target.checked && view_All && delete_All) {
          selectAll = true;
        } else {
          selectAll = false;
        }
        if (!view_All) {
          value.view = true;
        }
        if (e.target.checked) {
          value.view = true;
        }
        if (value) {
          setSelectCheck("");
        }
        value.edit = e.target.checked;
        return value;
      });
    });
    view_All = true;
    edit_All = e.target.checked;
    setAdminList(edit1);
  };

  const setViewall = (e) => {
    const view1 = JSON.parse(JSON.stringify(adminList));
    view1.map((item) => {
      return Object.entries(item).forEach(([key, value]) => {
        if (view_All && edit_All && delete_All) {
          selectAll = true;
        }

        if (!e.target.checked && !edit_All && !delete_All) {
          value.all = false;
          selectAll = false;
        }
        if (edit_All || delete_All) {
          value.view = true;
        } else {
          value.view = e.target.checked;
        }

        return value;
      });
    });
    view_All = edit_All || delete_All ? true : e.target.checked;

    setAdminList(view1);
  };

  const selectAlllist = (e) => {
    const select = JSON.parse(JSON.stringify(adminList));
    select.map((item) => {
      return Object.entries(item).forEach(([key, value]) => {
        value.view = e.target.checked;
        value.edit = e.target.checked;
        value.delete = e.target.checked;
        if (value) {
          setSelectCheck("");
        }
        return value;
      });
    });

    view_All = e.target.checked;
    edit_All = e.target.checked;
    delete_All = e.target.checked;

    selectAll = e.target.checked;
    setAdminList(select);
  };
  const submitsubadmin = (data) => {
    const dataset = JSON.parse(JSON.stringify(adminList));
    const valueset = dataset.map((item) => {
      return Object.entries(item).map(([key, value]) => {
        return value;
      });
    });
    const checkview = _.find(valueset[0], ["view", true]);
    const checkedit = _.find(valueset[0], ["edit", true]);
    const checkdelete = _.find(valueset[0], ["delete", true]);

    if (
      checkview === undefined &&
      checkedit === undefined &&
      checkdelete === undefined
    ) {
      setSelectCheck("This field is required");
      return;
    }

    const commonPayload = {
      userName: data.name,
      config: adminList[0],
    };
    Loader.isLoading(true);
    if (type === "add") {
      const Payload = {
        ...commonPayload,
        email: data.email,
        password: data.password,
      };
      APICall("post", Payload, EndPoints.AddSubAdmin)
        .then((response) => {
          const { isError, message } = response.data;
          if (!isError) {
            toast.success(message);
            onSubmitCreateSubAdminList();
            handleClose();
          } else {
            toast.error(message);
          }
         
        })
        .catch((error) => {
          return error;
        })
        .finally(() => {
          Loader.isLoading(false);
        });
    } else {
      const payload = {
        id: updateData.id,
        ...commonPayload,
      };
      APICall("post", payload, EndPoints.updateSubAdmin)
        .then((response) => {
          const { isError, message } = response.data;
          if (!isError) {
            toast.success(message);
            onSubmitCreateSubAdminList();
            handleClose();
          } else {
            toast.error(message);
          }
         
        })
        .catch((error) => {
          return error;
        })
        .finally(() => {
          Loader.isLoading(false);
        });
    }
  };
  let view_All = false;
  let edit_All = false;
  let delete_All = false;
  let selectAll = false;
  _.map(adminList, (item) => {
    const datavalue = Object.entries(item).map(([key, value]) => {
      return value;
    });
    const checkview = _.every(datavalue, ["view", true]);

    if (checkview) {
      view_All = true;
    }
    const checkedit = _.every(datavalue, ["edit", true]);

    if (checkedit) {
      edit_All = true;
    }
    const checkdelete = _.every(datavalue, ["delete", true]);

    if (checkdelete) {
      delete_All = true;
    }

    if (checkview && checkedit && checkdelete) {
      selectAll = true;
    }
  });

  return (
    <Drawer
      open={open}
      anchor="right"
      variant="temporary"
      onClose={handleClose}
      ModalProps={{ keepMounted: true }}
      sx={{ "& .MuiDrawer-paper": { width: { xs: 400, sm: 600 } } }}
    >
      <FormHeader heading={heading} onClick={handleClose} />
      <Box sx={{ p: 5 }}>
        <form onSubmit={handleSubmit(submitsubadmin)}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Controller
                  name="name"
                  control={control}
                  rules={{
                    required: true,
                    validate: isSpaceValidateTextField,
                  }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      value={value}
                      onChange={onChange}
                      fullWidth
                      type="text"
                      label="Name"
                      placeholder=" Enter name"
                      error={Boolean(errors.name)}
                      aria-describedby="validation-basic-first-name"
                    />
                  )}
                />
                {errors.name && (
                  <FormHelperText
                    sx={{ color: "error.main" }}
                    id="validation-basic-first-name"
                  >
                    This field is required
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: true,
                    validate: isSpaceValidateTextField,
                  }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      disabled={type === "edit"}
                      value={value}
                      onChange={onChange}
                      fullWidth
                      type="email"
                      label="Email"
                      placeholder="Enter email"
                      error={Boolean(errors.email)}
                      aria-describedby="validation-basic-first-name"
                    />
                  )}
                />
                {errors.email && (
                  <FormHelperText
                    sx={{ color: "error.main" }}
                    id="validation-basic-first-name"
                  >
                    This field is required
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            {type === "add" && (
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="password"
                    control={control}
                    rules={{
                      required: true,
                      validate: isSpaceValidateTextField,
                    }}
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        onChange={onChange}
                        fullWidth
                        type="password"
                        label="Password"
                        placeholder=" Enter password"
                        error={Boolean(errors.password)}
                        aria-describedby="validation-basic-first-name"
                      />
                    )}
                  />
                  {errors.password && (
                    <FormHelperText
                      sx={{ color: "error.main" }}
                      id="validation-basic-first-name"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "1rem",
                paddingTop: "0.4rem",
                flexDirection: "column",
                marginLeft: "1rem",
                paddingRight: "1rem",
                marginTop: "1rem",
                border: "1px solid ",
                borderColor: "rgb(208 208 215 / 87%)",
                borderRadius: "10px",
                display: "flex",
                fontSize: "0.9rem",
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  justifyContent: "flex-end",

                  flexDirection: "row",
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <FormControl
                    sx={{
                      width: "120px",
                    }}
                  >
                    <Controller
                      name="Selectall"
                      control={control}
                      rules={{ required: false }}
                      render={({ field: { value } }) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectAll}
                                onChange={(e) => {
                                  selectAlllist(e);
                                }}
                              />
                            }
                            label={
                              <Typography variant="body1" component="span">
                                Select All
                              </Typography>
                            }
                          />
                        );
                      }}
                    />
                  </FormControl>
                  <FormControl
                    sx={{
                      width: "80px",
                    }}
                  >
                    <Controller
                      name="View"
                      control={control}
                      rules={{ required: false }}
                      render={({ field: { value } }) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={view_All}
                                onChange={(e) => {
                                  setViewall(e);
                                }}
                              />
                            }
                            label={
                              <Typography variant="body1" component="span">
                                All
                              </Typography>
                            }
                          />
                        );
                      }}
                    />
                  </FormControl>
                  <FormControl
                    sx={{
                      width: "80px",
                    }}
                  >
                    <Controller
                      name="Edit"
                      control={control}
                      rules={{ required: false }}
                      render={({ field: { value } }) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={edit_All}
                                onChange={(e) => {
                                  setEditAll(e);
                                }}
                              />
                            }
                            label={
                              <Typography variant="body1" component="span">
                                All
                              </Typography>
                            }
                          />
                        );
                      }}
                    />
                  </FormControl>
                  <FormControl
                    sx={{
                      width: "80px",
                    }}
                  >
                    <Controller
                      name="Delete"
                      control={control}
                      rules={{ required: false }}
                      render={({ field: { value } }) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={delete_All}
                                onChange={(e) => {
                                  setDeteleAll(e);
                                }}
                              />
                            }
                            label={
                              <Typography variant="body1" component="span">
                                All
                              </Typography>
                            }
                          />
                        );
                      }}
                    />
                  </FormControl>
                </Box>
              </Box>

              {_.map(adminList, (item) => {
                return Object.entries(item).map(([key, value]) => {
                  let isAll = false;
                  if (value.view && value.edit && value.delete) {
                    isAll = true;
                  }
                  const title = _.split(key, "_");
                  const slice =
                    title[0].charAt(0).toUpperCase() + title[0].slice(1);
                  const textdata =
                    title.length === 1 ? slice : `${slice} ${title[1]}`;

                  return (
                    <Box
                      key={key}
                      sx={{
                        flex: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: "row",
                        display: "flex",
                      }}
                    >
                      <Typography>{textdata}</Typography>

                      <Box
                        sx={{
                          alignItems: "center",
                          flexDirection: "row",
                          display: "flex",
                        }}
                      >
                        <FormControl
                          sx={{
                            width: "120px",
                          }}
                        >
                          <Controller
                            name="all"
                            control={control}
                            rules={{ required: false }}
                            render={() => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="all"
                                      checked={isAll}
                                      onChange={(e) => {
                                        selectOne(e, key);
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="body1"
                                      component="span"
                                    >
                                      All
                                    </Typography>
                                  }
                                />
                              );
                            }}
                          />
                        </FormControl>
                        <FormControl
                          sx={{
                            width: "80px",
                          }}
                        >
                          <Controller
                            name="View"
                            control={control}
                            rules={{ required: false }}
                            render={() => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="view"
                                      checked={value.view}
                                      onChange={(e) => {
                                        selectOne(e, key);
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="body1"
                                      component="span"
                                    >
                                      View
                                    </Typography>
                                  }
                                />
                              );
                            }}
                          />
                        </FormControl>
                        <FormControl
                          sx={{
                            width: "80px",
                          }}
                        >
                          <Controller
                            name="Edit"
                            control={control}
                            rules={{ required: false }}
                            render={() => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="edit"
                                      checked={value.edit}
                                      onChange={(e) => {
                                        selectOne(e, key);
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="body1"
                                      component="span"
                                    >
                                      Edit
                                    </Typography>
                                  }
                                />
                              );
                            }}
                          />
                        </FormControl>
                        <FormControl
                          sx={{
                            width: "80px",
                          }}
                        >
                          <Controller
                            name="Delete"
                            control={control}
                            rules={{ required: false }}
                            render={() => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="delete"
                                      checked={value.delete}
                                      onChange={(e) => {
                                        selectOne(e, key);
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="body1"
                                      component="span"
                                    >
                                      Delete
                                    </Typography>
                                  }
                                />
                              );
                            }}
                          />
                        </FormControl>
                      </Box>
                    </Box>
                  );
                });
              })}
            </Grid>
            <Grid
              item
              xs={12}
              pl={4}
              sx={{
                "&.MuiGrid-root": {
                  paddingTop: "0rem",
                  paddingBottom: "1rem",
                },
              }}
            >
              {selectcheck && (
                <FormHelperText
                  sx={{
                    color: "error.main",
                  }}
                  id="validation-basic-first-name"
                >
                  This field is required
                </FormHelperText>
              )}
            </Grid>

            <FormButtons type={type} resetFunction={resetToEmptyValues} />
          </Grid>
        </form>
      </Box>
    </Drawer>
  );
};

export default AddCreateSubAdmin;
